module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.owners')))]), _vm._v(" "), _c('base-list', {
    attrs: {
      "model": "owners",
      "columns": ['name', 'contact_name'],
      "s-model": "owner"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-11b0b510!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/owner/OwnerList.vue
// module id = 1124
// module chunks = 2